import IMG1 from "../../img/testimonial/abraham.png";
import IMG2 from "../../img/testimonial/chioma.png";
import IMG3 from "../../img/testimonial/amen.png";

export const Data = [
  {
    id: 1,
    title: "Yunana Abraham",
    image: IMG1,
    comment:
      '"The website you built for us has increased our online presence and hence ameliorated our ease of business. Strangers are now more comfortable to engage in first time deals "',
  },
  {
    id: 2,
    title: "Theresa C. Olewunne",
    image: IMG2,
    comment:
      '"We were at a point where our business needed to move completely automated as the growth was getting better but so was the manual demand. The software solution you provided aided in faster turnaround time and at lower cost. "',
  },
  {
    id: 3,
    title: "Amen Omere",
    image: IMG3,
    comment:
      '"By developing our website, Our reach and acceptability improved. The interface is very appealing and user-friendly and as such has given us multiple levelled referrals"',
  },
];
